import { render, staticRenderFns } from "./SchemaFaq.vue?vue&type=template&id=69ad0530&"
import script from "./SchemaFaq.vue?vue&type=script&lang=js&"
export * from "./SchemaFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports